import tag from './tag'
import tagWhite from './tag-white'
import tagDark from './tag-dark'

export default {
  tag,
  'tag-white': tagWhite,
  'tag-dark': tagDark
}
